const LOCALE_DATA = {
  nl: { 
    days: ["Ma","Di","Wo","Do","Vr","Za","Zo"], 
    months: ["Januari","Februari","Maart","April","Mei","Juni","Juli","Augustus","September","Oktober","November","December"], 
    minDays: 0, 
    tz: "Europe/Amsterdam", 
    msg: "Bezorgdatum:" 
  },
  be: { 
    days: ["Ma","Di","Wo","Do","Vr","Za","Zo"], 
    months: ["Januari","Februari","Maart","April","Mei","Juni","Juli","Augustus","September","Oktober","November","December"], 
    minDays: 0, 
    tz: "Europe/Amsterdam", 
    msg: "Bezorgdatum:" 
  },
  de: { 
    days: ["Mo","Di","Mi","Do","Fr","Sa","So"], 
    months: ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"], 
    minDays: 2, 
    tz: "Europe/Berlin", 
    msg: "Lieferdatum:" 
  },
  ch: { 
    days: ["Mo","Di","Mi","Do","Fr","Sa","So"], 
    months: ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"], 
    minDays: 4, 
    tz: "Europe/Berlin", 
    msg: "Lieferdatum:" 
  },
  at: { 
    days: ["Mo","Di","Mi","Do","Fr","Sa","So"], 
    months: ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"], 
    minDays: 4, 
    tz: "Europe/Berlin", 
    msg: "Lieferdatum:" 
  },
  fr: { 
    days: ["Lun","Mar","Mer","Jeu","Ven","Sam","Dim"], 
    months: ["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"], 
    minDays: 2, 
    tz: "Europe/Paris", 
    msg: "Date de livraison:" 
  },
  en: { 
    days: ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"], 
    months: ["January","February","March","April","May","June","July","August","September","October","November","December"], 
    minDays: 2, 
    tz: "Europe/London", 
    msg: "Delivery date:" 
  },
  ie: { 
    days: ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"], 
    months: ["January","February","March","April","May","June","July","August","September","October","November","December"], 
    minDays: 2, 
    tz: "Europe/London", 
    msg: "Delivery date:" 
  },
  it: { 
    days: ["Lun","Mar","Mer","Gio","Ven","Sab","Dom"], 
    months: ["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"], 
    minDays: 3, 
    tz: "Europe/Rome", 
    msg: "Data di consegna:" 
  },
  es: { 
    days: ["Lun","Mar","Mié","Jue","Vie","Sáb","Dom"], 
    months: ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"], 
    minDays: 3, 
    tz: "Europe/Madrid", 
    msg: "Fecha de entrega:" 
  },
  da: { 
    days: ["Man","Tir","Ons","Tor","Fre","Lør","Søn"], 
    months: ["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"], 
    minDays: 2, 
    tz: "Europe/Copenhagen", 
    msg: "Leveringsdato:" 
  },
  sv: { 
    days: ["Mån","Tis","Ons","Tor","Fre","Lör","Sön"], 
    months: ["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"], 
    minDays: 3, 
    tz: "Europe/Stockholm", 
    msg: "Leveransdatum:" 
  }
};

const WEEKEND_FIXED_DAY = {
  nl: 2, be: 2,
  en: 3, uk: 3, de: 3, fr: 3, da: 3,
  it: 4, es: 4, sv: 4, ch: 4, ie: 3,
};

// ============================================================
// VAKANTIE-INSTELLINGEN
// Let op: maanden tellen vanaf 0 (0 = januari, 8 = september, 9 = oktober)
// ------------------------------------------------------------
// lastShipDay : laatste dag waarop nog verzonden wordt
// cutoffHour  : tot hoe laat op die dag bestellingen nog mee gaan
// resumeDay   : eerste dag waarop weer verzonden wordt
// ============================================================
const VACATION = {
  lastShipDay: new Date(2026, 8, 25),  // vrijdag 25 september 2026
  cutoffHour:  15,                     // bestellingen tot 15:00 gaan nog mee
  resumeDay:   new Date(2026, 9, 12),  // maandag 12 oktober 2026
};

function getLocale() {
  try {
    const host = window.location.hostname; // "rosenblaettershop.ch"
    
    if (host.endsWith(".ch")) return "ch";
    if (host.endsWith(".at")) return "at";
    if (host.endsWith(".be")) return "be";
    if (host.endsWith(".ie")) return "ie";
    if (host.endsWith(".de")) return "de";
    if (host.endsWith(".fr")) return "fr";
    if (host.endsWith(".it")) return "it";
    if (host.endsWith(".es")) return "es";
    if (host.endsWith(".dk")) return "da";
    if (host.endsWith(".se")) return "sv";
    if (host.endsWith(".co.uk") || host.endsWith(".uk")) return "en";
    if (host.endsWith(".nl"))  return "nl";
    
    // Fallback
    return "nl";
  } catch (e) { return "nl"; }
}

function getLocaleData() {
  return LOCALE_DATA[getLocale()] || LOCALE_DATA["nl"];
}

let _serverTimeOffset = null;

async function initServerTime() {
  try {
    const before = Date.now();
    const res = await fetch(`${window.Shopify.routes.root}cart.js?_=${Math.random()}`);
    const after = Date.now();
    const serverDateStr = res.headers.get("Date");
    if (serverDateStr) {
      const serverMs = new Date(serverDateStr).getTime();
      const clientMs = Math.round((before + after) / 2);
      _serverTimeOffset = serverMs - clientMs;
    }
  } catch (e) {
    console.warn("Servertijd niet beschikbaar, valt terug op lokale tijd:", e);
    _serverTimeOffset = 0;
  }
}

function getNow(tz) {
  const trueNow = new Date(Date.now() + (_serverTimeOffset ?? 0));
  return new Date(trueNow.toLocaleString("en-US", { timeZone: tz }));
}

function formatDisplay(d) {
  const day = String(d.getDate()).padStart(2, "0");
  const m   = String(d.getMonth() + 1).padStart(2, "0");
  return `${day}-${m}-${d.getFullYear()}`;
}

function getDayName(d) {
  return ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"][d.getDay()];
}

function skipWeekend(d) {
  while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
  return d;
}

function dayOnly(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

// ---- Vakantie helpers ----

// Moment waarop de vakantie ingaat (laatste verzenddag + cutoff-uur)
function getVacationStart() {
  const s = new Date(VACATION.lastShipDay);
  s.setHours(VACATION.cutoffHour, 0, 0, 0);
  return s;
}

// Zit "now" in de periode waarin niet verzonden wordt?
function isInVacation(now) {
  return now >= getVacationStart() && now < dayOnly(VACATION.resumeDay);
}

// Laatst mogelijke bezorgdag van de laatste zending vóór de vakantie
function getLastDeliveryBeforeVacation() {
  const data = getLocaleData();
  return addWorkdays(VACATION.lastShipDay, Math.max(data.minDays, 1));
}

// Eerst mogelijke bezorgdag na de vakantie (volgens de normale logica)
function getFirstDeliveryAfterVacation() {
  return calcMinDate(new Date(dayOnly(VACATION.resumeDay)));
}

// Valt een bezorgdatum in het geblokkeerde gat door de vakantie?
function isVacationBlocked(date) {
  const d0    = dayOnly(date);
  const last  = dayOnly(getLastDeliveryBeforeVacation());
  const first = dayOnly(getFirstDeliveryAfterVacation());
  return d0 > last && d0 < first;
}

// ---- Minimale datum ----

// Originele logica, maar nu op basis van een meegegeven "now"
function calcMinDate(now) {
  const data = getLocaleData();
  const loc  = getLocale();
  const dow  = now.getDay();
  const hour = now.getHours();

  if (dow === 6) {
    const t = new Date(now);
    t.setDate(t.getDate() + 2); 
    return addWorkdays(t, Math.max(data.minDays, 1));
  }

  const isWeekendCutoff =
    (dow === 5 && hour >= 15) ||
    dow === 0 ||
    (dow === 1 && hour < 15);

  if (isWeekendCutoff) {
    const targetDow = WEEKEND_FIXED_DAY[loc] || 4;
    const t = new Date(now);
    t.setDate(t.getDate() + 1);
    while (t.getDay() !== targetDow) t.setDate(t.getDate() + 1);
    return t;
  }

  const t = new Date(now);
  let daysToAdd = Math.max(data.minDays, 1);
  if (hour >= 15) daysToAdd += 1;
  return addWorkdays(t, daysToAdd);
}

function getMinDate() {
  const data = getLocaleData();
  let now = getNow(data.tz);

  // Tijdens de vakantie rekenen we alsof het maandagochtend na de vakantie is
  if (isInVacation(now)) {
    now = new Date(dayOnly(VACATION.resumeDay));
  }

  return calcMinDate(now);
}

function addWorkdays(from, workdays) {
  const t = new Date(from);
  let added = 0;
  while (added < workdays) {
    t.setDate(t.getDate() + 1);
    if (t.getDay() !== 0 && t.getDay() !== 6) added++;
  }
  return t;
}

let viewDate     = new Date();
let selectedDate = null;
let calOpen      = false;

const labelMsg      = document.getElementById("delivery_date_picker_msg");
const dateInput     = document.getElementById("dateInput");
const calendar      = document.getElementById("calendar");
const daysContainer = document.getElementById("daysContainer");
const monthYear     = document.getElementById("monthYear");
const triggerBox    = document.getElementById("calender-input-box-id");

(function fixCalendarIcon() {
  const icon = document.getElementById("calender-icon");
  if (!icon) return;
  icon.style.width        = "20px";
  icon.style.height       = "20px";
  icon.style.color        = "#51200e";
  icon.style.flexShrink   = "0";
  icon.style.pointerEvents = "none";
  icon.style.display      = "block";
})();

function isDisabled(date, minDate) {
  const d0 = dayOnly(date);
  const m0 = dayOnly(minDate);
  return d0 < m0 ||
         date.getDay() === 0 ||
         date.getDay() === 6 ||
         isVacationBlocked(date);
}

function renderCalendar() {
  daysContainer.innerHTML = "";
  const data    = getLocaleData();
  const minDate = getMinDate();

  data.days.forEach((d) => {
    const el = document.createElement("div");
    el.classList.add("day-header");
    el.textContent = d;
    daysContainer.appendChild(el);
  });

  const firstDayIndex = (new Date(viewDate.getFullYear(), viewDate.getMonth(), 1).getDay() + 6) % 7;
  for (let i = 0; i < firstDayIndex; i++) {
    const el = document.createElement("div");
    el.classList.add("day", "empty");
    daysContainer.appendChild(el);
  }

  const lastDay = new Date(viewDate.getFullYear(), viewDate.getMonth() + 1, 0).getDate();
  for (let day = 1; day <= lastDay; day++) {
    const date = new Date(viewDate.getFullYear(), viewDate.getMonth(), day);
    const el   = document.createElement("div");
    el.classList.add("day");

    if (date.toDateString() === minDate.toDateString()) el.classList.add("current");
    if (selectedDate && date.toDateString() === selectedDate.toDateString()) el.classList.add("selected");

    if (isDisabled(date, minDate)) {
      el.classList.add("disabled");
      el.style.pointerEvents = "none";
    } else {
      el.addEventListener("click", () => handleDayClick(date));
    }

    el.textContent = day;
    daysContainer.appendChild(el);
  }

  monthYear.textContent = `${data.months[viewDate.getMonth()]} ${viewDate.getFullYear()}`;
}

function handleDayClick(date) {
  selectedDate    = date;
  dateInput.value = formatDisplay(date);
  closeCalendar();
  updateCart(formatDisplay(date), getDayName(date));
}

function openCalendar() {
  calOpen  = true;
  // Open op de maand van de gekozen datum, anders op de maand van de eerst mogelijke datum
  viewDate = selectedDate ? new Date(selectedDate) : new Date(getMinDate());
  viewDate.setDate(1);
  renderCalendar();
  calendar.style.display = "block";
}

function closeCalendar() {
  calOpen = false;
  calendar.style.display = "none";
}

triggerBox.addEventListener("click", (e) => {
  e.stopPropagation();
  calOpen ? closeCalendar() : openCalendar();
});

document.addEventListener("click", (e) => {
  if (calOpen && !calendar.contains(e.target) && !triggerBox.contains(e.target)) {
    closeCalendar();
  }
});

calendar.addEventListener("click", (e) => e.stopPropagation());

document.getElementById("prevBtn").addEventListener("click", (e) => {
  e.stopPropagation();
  viewDate.setMonth(viewDate.getMonth() - 1);
  renderCalendar();
});

document.getElementById("nextBtn").addEventListener("click", (e) => {
  e.stopPropagation();
  viewDate.setMonth(viewDate.getMonth() + 1);
  renderCalendar();
});

function updateCart(dateStr, dayName) {
  fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method:  "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      attributes: {
        "Order Type":    "Shipping",
        "Delivery Date": dateStr,
        "Delivery Day":  dayName,
        "Date Format":   "dd-mm-yyyy",
      },
    }),
  })
    .then((r) => r.json())
    .then((d) => console.log("Cart bijgewerkt:", d))
    .catch((e) => console.error("Cart update mislukt:", e));
}

async function restoreCartDate() {
  try {
    const res  = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await res.json();
    if (cart.attributes?.["Delivery Date"]) {
      const parts = cart.attributes["Delivery Date"].split("-");
      if (parts.length === 3) {
        const restored = new Date(parts[2], parts[1] - 1, parts[0]);
        const minDate  = getMinDate();
        // Nu ook controleren op weekend en vakantieperiode
        if (!isDisabled(restored, minDate)) {
          selectedDate    = restored;
          dateInput.value = cart.attributes["Delivery Date"];
        } else {
          selectedDate    = minDate;
          dateInput.value = formatDisplay(minDate);
          updateCart(formatDisplay(minDate), getDayName(minDate));
        }
      }
    }
  } catch (e) {
    console.warn("Kon cart-datum niet herstellen:", e);
  }
}

function startDateValidityWatcher() {
  const CHECK_INTERVAL_MS = 10 * 1000;

  function revalidate() {
    const minDate = getMinDate();
    const m0 = dayOnly(minDate);

    if (dateInput && !dateInput.value) {
      dateInput.setAttribute("placeholder", formatDisplay(minDate));
    }

    let current = selectedDate;
    if (!current && dateInput?.value) {
      const parts = dateInput.value.split("-");
      if (parts.length === 3) {
        current = new Date(parts[2], parts[1] - 1, parts[0]);
      }
    }

    if (current) {
      const c0 = dayOnly(current);
      const isTooEarly    = c0 < m0;
      const isWeekend     = current.getDay() === 0 || current.getDay() === 6;
      const isNowDisabled = isDisabled(current, minDate); // incl. vakantie

      if (isTooEarly || isWeekend || isNowDisabled) {
        console.log(
          `[DateWatcher] Datum ongeldig (${isTooEarly ? "te vroeg" : isWeekend ? "weekend" : "niet meer beschikbaar"}), corrigeer naar:`,
          formatDisplay(minDate)
        );
        selectedDate    = minDate;
        dateInput.value = formatDisplay(minDate);  
        dateInput.setAttribute("placeholder", formatDisplay(minDate));

        if (calOpen) renderCalendar();
        updateCart(formatDisplay(minDate), getDayName(minDate));
      }
    } else {
      dateInput.setAttribute("placeholder", formatDisplay(minDate));
    }
  }

  setInterval(revalidate, CHECK_INTERVAL_MS);
}

const HIDDEN_WHEN_ONLY_SKU = 'Sample'; 

function updateDateFieldVisibility(cartData) {
  const outer = document.querySelector('.cart_date_outer');
  if (!outer) return;

  const items = cartData.items || [];
  const hideField =
    items.length === 1 &&
    items[0].sku === HIDDEN_WHEN_ONLY_SKU;

  outer.style.display = hideField ? 'none' : '';
}

async function checkCartForDateField() {
  try {
    const res  = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await res.json();
    updateDateFieldVisibility(cart);
  } catch (e) {
    console.warn('Kon cart niet ophalen voor datumveld:', e);
  }
}

document.addEventListener('cart:refresh',  checkCartForDateField);
document.addEventListener('cart:updated',  checkCartForDateField);

const cartList = document.querySelector('.cart-item-list__body');
if (cartList) {
  new MutationObserver(checkCartForDateField).observe(cartList, { childList: true, subtree: true });
}

(async function init() {
  await initServerTime();

  // Labels initialiseren met correcte servertijd
  const data    = getLocaleData();
  const minDate = getMinDate();
  if (labelMsg) labelMsg.textContent = data.msg;
  if (dateInput) dateInput.setAttribute("placeholder", formatDisplay(minDate));

  await restoreCartDate();
  checkCartForDateField();
  startDateValidityWatcher();
})();